import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IInvitationToken } from '@/shared/model/invitation-token.model';

const baseApiUrl = 'api/invitation-tokens';
const baseSearchApiUrl = 'api/_search/invitation-tokens?query=';

export default class InvitationTokenService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IInvitationToken> {
    return new Promise<IInvitationToken>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IInvitationToken): Promise<IInvitationToken> {
    return new Promise<IInvitationToken>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IInvitationToken): Promise<IInvitationToken> {
    return new Promise<IInvitationToken>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
